export const swiperOptions = {
  default: {
    loop: true,
    spaceBetween: 0,
    autoplay: {
      disableOnInteraction: false,
      delay: 4000
    }
  },
  // 异形轮播图, 表现样式参考preview/special-shaped.png
  specialShaped: {
    watchSlidesProgress: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    loopedSlides: 3, // 显示的数量, 默认为3
    autoplay: {
      disableOnInteraction: false
    },
    on: {
      progress: function(progress) {
        for (let i = 0; i < this.slides.length; i++) {
          let slide = this.slides.eq(i);
          let slideProgress = this.slides[i].progress;
          let modify = 1;
          if (Math.abs(slideProgress) > 1) {
            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
          }
          // 680为左边的节点边缘刚好可以显示的值
          let translate = slideProgress * modify * 680 + 'px';
          let scale = 1 - Math.abs(slideProgress) / 4.5;
          let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
          slide.transform('translateX(' + translate + ') scale(' + scale + ')');
          slide.css('zIndex', zIndex);
          slide.css('opacity', 1);
          // 2 为目前只显示额外2个节点
          if (Math.abs(slideProgress) > 2) {
            slide.css('opacity', 0);
          }
        }
      },
      setTransition: function(transition) {
        for (let i = 0; i < this.slides.length; i++) {
          let slide = this.slides.eq(i);
          slide.transition(transition);
        }
      }
    }
  },
  // 获取自定义的异形轮播图参数
  getCustomizeSpecialShaped: ({ loop = true, loopedSlides = 3, autoplay = true, deviation = 680 }) => {
    return {
      watchSlidesProgress: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: loop,
      loopedSlides: loopedSlides, // 显示的数量, 默认为3
      autoplay: autoplay && {
        disableOnInteraction: false
      },
      on: {
        progress: function(progress) {
          for (let i = 0; i < this.slides.length; i++) {
            let slide = this.slides.eq(i);
            let slideProgress = this.slides[i].progress;
            let modify = 1;
            if (Math.abs(slideProgress) > 1) {
              modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
            }
            // 680为左边的节点边缘刚好可以显示的值
            let translate = slideProgress * modify * deviation + 'px';
            let scale = 1 - Math.abs(slideProgress) / 4.5;
            let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
            slide.transform('translateX(' + translate + ') scale(' + scale + ')');
            slide.css('zIndex', zIndex);
            slide.css('opacity', 1);
            // 2 为目前只显示额外2个节点
            if (Math.abs(slideProgress) > loopedSlides - 1) {
              slide.css('opacity', 0);
            }
          }
        },
        setTransition: function(transition) {
          for (let i = 0; i < this.slides.length; i++) {
            let slide = this.slides.eq(i);
            slide.transition(transition);
          }
        }
      }
    };
  }
};
